import { waitOnline } from '../../wait-online';

export const tryLoad = async (callback: Function): Promise<any> => {
	for (let retryCount = 0; retryCount <= 3; retryCount++)
	{
		try
		{
			// eslint-disable-next-line no-await-in-loop
			return await callback();
		}
		catch (error)
		{
			const retryLog = retryCount > 0 ? `Retry #${retryCount}` : '';

			console.error(`${callback} ${retryLog}`, error);

			// eslint-disable-next-line no-await-in-loop
			await waitOnline();
		}
	}

	return null;
};
